import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { MoreVertical, Pencil, UserX } from 'lucide-react';
import type { RecruitmentCandidate } from './types';
import { LW_DS_CLASS } from '@/components/lw';

interface RecruitmentRowActionsProps {
  candidate: RecruitmentCandidate;
  onEdit: (candidate: RecruitmentCandidate) => void;
  onTerminate?: (candidate: RecruitmentCandidate) => void;
}

export const RecruitmentRowActions: React.FC<RecruitmentRowActionsProps> = ({
  candidate,
  onEdit,
  onTerminate
}) => {
  const handleEdit = () => {
    onEdit(candidate);
  };

  const handleTerminate = () => {
    if (onTerminate) {
      onTerminate(candidate);
    }
  };

  // Check if candidate is already terminated or has no Gmail account
  const canTerminate = candidate.status !== 'Terminated' && onTerminate;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="iconbtn" aria-label="Open menu" type="button">
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={`${LW_DS_CLASS} w-48`}>
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleEdit}>
          <Pencil className="mr-2 h-4 w-4" />
          Edit Candidate
        </DropdownMenuItem>
        {canTerminate && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={handleTerminate}
              className="text-red-600 focus:text-red-600 focus:bg-red-50"
            >
              <UserX className="mr-2 h-4 w-4" />
              Terminate
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
